<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>基础佣金</span>
                </div>
            </template>
            <el-table :data="defaultValueList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="item_name" label="项" />
                <el-table-column prop="item_value" label="值" />
                <el-table-column label="是否真实结算">
                    <template #default="scope">
                        {{ scope.row.is_settlement === 0 ? '否' : '是' }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const defaultValueList = ref([])

        const goback = () => {
            router.go(-1)
        }

        const getDefaultValueListList = ({ partner_code }) => {
            return api.SalesPartnerModelDefaultValueList({ partner_code }).then(res => {
                if (res.data.code === 200) {
                    defaultValueList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        onMounted(() => {
            const partner_code = route.params.partner_code
            if (partner_code) {
                getDefaultValueListList({ partner_code })
            }
        })

        return {
            goback,
            getDefaultValueListList,
            defaultValueList
        }
    }
}
</script>